<app-header [logged]="true"  ></app-header>
<mat-drawer-container class="example-container">
  <mat-drawer class="p-3" mode="side" opened>
    <div  class="ml-3 mr-3" id="profileImage" [innerHTML] = "initials" ></div>
    <h2 class="ml-3 mr-3" >
      {{ first_name }}
      {{ last_name }}
    </h2>
    <p  class="ml-3 mr-3">
      @{{blog_data.profile_url}}
    </p>

    <button (click)="createBlog()" class="mt-3 ml-3 mr-3" mat-raised-button color="accent">
      <mat-icon>add</mat-icon>
      Create new blog
    </button>

    <mat-divider class="mt-3 mb-3" ></mat-divider>

    <div *ngFor="let blog of blog_list; let i = index" >
      <mat-card [ngClass]="{'active': selected_index == i }" class="mb-3 ml-3 mr-3" (click)="selectBlog(i)" >
        {{ blog.blog_name }}
      </mat-card>
    </div>
  </mat-drawer>
  <mat-drawer-content>
    <div class=" pt-3">
      <app-create-blog  [username]="blog_data.username"  *ngIf='showCreateBlog'></app-create-blog>
      <app-comment-box *ngIf='showDeveloper && !showCreateBlog' [comment_data]="comment_data"  [path]='path' ></app-comment-box>
      <app-dashboard *ngIf='!showDeveloper && !showCreateBlog' [path]='path'></app-dashboard>
    </div>

  </mat-drawer-content>
</mat-drawer-container>
<div >
  <app-footer  ></app-footer>
</div>
